import React, { useEffect, useState } from 'react';
import { styled } from 'linaria/react'
import { useSiteSettingsQuery } from '../../../hooks/useSiteSettings'
import { Product_Page_Settings } from '../../CustomElements/elementTypes'
import { theme } from '../../Theme'
import CategoryTree from '../../CategoryPage/Widgets/CategoryTree'
import useDigifiCategoryTree from '../../DigifiSearch/Hooks/useDigifiCategoryTree'
import FilterTags from '../../CategoryPage/Filters/FilterTags'
import MobileFilterDrawer from '../../CategoryPage/Filters/MobileFilterDrawer'
import { EXPECTED_PX_HEADER_HEIGHT } from '../Util/Constants'
import { useIntl } from '@jetshop/intl'
import Pagination from '../../CategoryPage/Widgets/Pagination'
import SearchBox from '../../CategoryPage/Filters/SearchBox'
import FilterList from '../../CategoryPage/Filters/FilterList'
import ProductListToolbar from '../../CategoryPage/Filters/ProductListToolbar'
import MobileFilterButtons from '../../CategoryPage/Filters/MobileFilterButtons'
import MobileFilterList, { getActiveFilterCount } from '../../CategoryPage/Filters/MobileFilterList'
import FilterPanelFooter from '../../CategoryPage/Filters/FilterPanelFooter'
import ProductHitsGrid from './ProductHitsGrid'
import { DIGIFI_DEFAULT_PAGE_SIZE, DIGIFI_FILTER_FIELD_NAMES } from '../../DigifiSearch/constants'
import NextPrevPageMetaLinks from '../../CategoryPage/Widgets/NextPrevPageMetaLinks'
import { useDigifiProductSearch } from '../../DigifiSearch/Hooks/useDigifiProductSearch';
import FilterButtonsSkeleton from '../Skeletons/FilterButtonsSkeleton';

const ProductListWrapper = styled.div`
   background-color: ${theme.colors.white};

   .main-container {
      background-color: ${theme.colors.white};
      padding-top: 0.5rem;

      ${theme.above.lg} {
         padding-top: 2rem;
      }
   }

   ${theme.below.lg} {
      .filter-buttons {
         margin-bottom: 0.5rem;
      }
   }

   ${theme.below.md} {
      .content-container {
         background-color: ${theme.colors.white};
         margin-left: 0px;
      }
      .filter-buttons {
         padding-right: 1rem;
         padding-left: 1rem;
      }
   }

   .product-list-wrapper {
      height: 100%;
      background-color: ${theme.colors.white};
      border-top-left-radius: 32px 32px;
      padding-right: inherit;
      padding-right: 0.5rem;
      padding-left: 0.5rem;

      ${theme.above.md} {
         padding-right: 4rem;
         padding-left: 0rem;
      }
      ${theme.above.lg} {
         padding-left: 2.5rem;
      }
      ${theme.above.xl} {
         padding-left: 4rem;
      }
      ${theme.above.xxl} {
         padding-right: 8rem;
      }
   }

   .filter-tags-wrapper {
      background-color: ${theme.colors.white};
   }

   .product-toolbar-wrapper {
      position: relative;
      z-index: 2;
      padding-top: 0.5rem;
      padding-bottom: 0.75rem;
      ${theme.above.lg} {
         padding-left: 2.5rem;
         padding-right: 4rem;
      }
      ${theme.above.xl} {
         padding-left: 4rem;
      }
      ${theme.above.xxl} {
         padding-right: 8rem;
      }
   }

   .sticky-filter-menu-desktop {
      background-color: ${theme.colors.white};
      /* position: -webkit-sticky;
      position: sticky;
      top: ${EXPECTED_PX_HEADER_HEIGHT.md};
      z-index: 99;
      max-height: calc(100vh - ${EXPECTED_PX_HEADER_HEIGHT.md});
      overflow-y: auto;
      ${theme.above.xl} {
         top: ${EXPECTED_PX_HEADER_HEIGHT.lg};
         max-height: calc(100vh - ${EXPECTED_PX_HEADER_HEIGHT.lg});
      } */
   }

   .side-panel {
      z-index: 1;
      background-color: ${theme.colors.white};
      min-width: 280px;
   }

   .category-tree-wrapper {
      /* border-top: 1px solid var(--color-separator); */
   }

   .product-results-wrapper {
      flex: 3;
   }

   .price-accordion {
      border-bottom: 1px solid var(--color-separator) !important;
      margin-bottom: 1rem;
   }

   .sticky-filter-menu-desktop .accordion-wrapper:first-child .top-separator {
      border-top: ${props => props.showTopAccordionSeparator ? '1px solid var(--color-separator)' : '1px solid transparent'} !important;
   }
`

const getDeafultSearchFilterForCategory = (categoryId) => {
   switch (categoryId) {
      case 3990:  // New products
         return {
            fieldName: DIGIFI_FILTER_FIELD_NAMES.IS_NEW,
            value: true
         }
      case 3991:  // Campaign page
         return {
            fieldName: DIGIFI_FILTER_FIELD_NAMES.IS_CAMPAIGN,
            value: true
         }
      default: // Default category filter
         return {
            fieldName: DIGIFI_FILTER_FIELD_NAMES.FILTER_CATEGORIES,
            value: categoryId
         }
   }
}

export const getUiConfig = (categoryId) => {
   switch (categoryId) {
      case 3990: // New products
         return {
            showCategoryTree: true,
         }
      case 3991: // Campaign page
         return {
            showCategoryTree: true,
         }
      default: // Default category filter
         return {
            showCategoryTree: true,
         }
   }
 }

const CategoryProductList = ({ category: { id: categoryId, name: categoryName } = {} }) => {
   const [searchValue, setSearchValue] = useState('');
   const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
   const [isMobileCategoriesOpen, setIsMobileCategoriesOpen] = useState(false);
   const [showSkeleton, setShowSkeleton] = useState(true);
   const t = useIntl();
   const [getSetting, loadingSiteSettings] = useSiteSettingsQuery()
   const productSettings = getSetting(null, Product_Page_Settings)
   const { topLevelCategory, hasSubCategories } = useDigifiCategoryTree(categoryId);
   const {
      products,
      filters,
      facets,
      updateFilters,
      resetTagFilters,
      loading,
      metaData,
   } = useDigifiProductSearch(
      categoryId && getDeafultSearchFilterForCategory(categoryId)
   );

   useEffect(() => {
      setShowSkeleton(!categoryId)
   }, [categoryId])

   const uiConfig = getUiConfig(categoryId)

   return (
      <React.Fragment>
         <NextPrevPageMetaLinks currentPage={metaData?.currentPage} totalPages={metaData?.totalPages} />
         <ProductListWrapper showTopAccordionSeparator={uiConfig.showCategoryTree && hasSubCategories}>
            <div id="last-page-scroll-anchor" className="main-container container-fluid pe-0 ps-0">
               <div className="content-container d-block d-lg-flex ml-128">
                  <div className={`side-panel col-lg-2 d-none d-lg-block br-8}`}>
                     <div className="sticky-filter-menu-desktop pb-32">
                        <SearchBox
                           searchValue={searchValue}
                           setSearchValue={setSearchValue}
                           onSearchChange={searchValue => {
                              updateFilters([
                                 {
                                    fieldName: DIGIFI_FILTER_FIELD_NAMES.SEARCH_QUERY,
                                    value: searchValue,
                                 },
                              ])
                           }}
                           placeholder={t('Search in {categoryName}', {
                              categoryName: categoryName ?? '',
                           })}
                        />
                        <div className="primary-shadow px-16 br-8 pb-32">
                           {uiConfig.showCategoryTree && hasSubCategories && (
                              <div className="category-tree-wrapper">
                                 <CategoryTree
                                    rootCategoryTitle={t('categories')}
                                    category={topLevelCategory}
                                    selectedCategoryId={categoryId}
                                    isRootLevelComp={true}
                                    initiallyExpanded={true}
                                 />
                              </div>
                           )}
                           <FilterList
                              filters={filters}
                              facets={facets}
                              updateFilters={updateFilters}
                              hideFilters={[
                                 DIGIFI_FILTER_FIELD_NAMES.BRAND,
                                 DIGIFI_FILTER_FIELD_NAMES.SORT_BY,
                                 DIGIFI_FILTER_FIELD_NAMES.PRICE,
                                 DIGIFI_FILTER_FIELD_NAMES.PREBOOK,
                              ]}
                           />
                        </div>
                     </div>
                  </div>

                  <div className="product-results-wrapper">
                     <div className="filter-tags-wrapper">
                        <div className="product-toolbar-wrapper d-none d-lg-block">
                           <ProductListToolbar
                              filters={filters}
                              facets={facets}
                              metaData={metaData}
                              updateFilters={updateFilters}
                           />
                        </div>
                        <div className="d-block d-lg-none">
                           {showSkeleton ? <FilterButtonsSkeleton /> : (
                           <MobileFilterButtons
                              className="filter-buttons py-8"
                              showCategoriesButton={uiConfig.showCategoryTree && hasSubCategories}
                              onCategoriesClick={() => setIsMobileCategoriesOpen(prev => !prev)}
                              onFilterClick={() => setIsMobileFilterOpen(prev => !prev)}
                              activeFilterCount={getActiveFilterCount(filters)}
                           />
                           )}
                        </div>
                        <FilterTags
                           filters={filters}
                           facets={facets}
                           visibleFilterTagsByFieldName={[
                              DIGIFI_FILTER_FIELD_NAMES.PRICE,
                              DIGIFI_FILTER_FIELD_NAMES.BRAND,
                              DIGIFI_FILTER_FIELD_NAMES.PRODUCT_TYPE,
                              DIGIFI_FILTER_FIELD_NAMES.STOCK_STATUS,
                              DIGIFI_FILTER_FIELD_NAMES.PREBOOK,
                              DIGIFI_FILTER_FIELD_NAMES.SORT_BY,
                           ]}
                           updateFilters={updateFilters}
                           onClearFilters={() => {
                              resetTagFilters({
                                 filtersByFieldNameToPreserve: [],
                              })
                              setSearchValue('')
                           }}
                        />
                     </div>

                     <div className="product-list-wrapper pb-32 pr-128">
                        <ProductHitsGrid
                           products={products}
                           productSettings={productSettings}
                           loading={loading}
                           loadingCardsCount={DIGIFI_DEFAULT_PAGE_SIZE}
                        />
                        <div className="w-100 d-flex justify-content-center pt-32">
                           <Pagination
                              metaData={metaData}
                              updateFilters={updateFilters}
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div className="d-block d-lg-none">
               <MobileFilterDrawer
                  title={'Filter'}
                  isOpen={isMobileFilterOpen}
                  setIsOpen={setIsMobileFilterOpen}
                  footer={
                     <FilterPanelFooter
                        clearLabel={t('Clear all')}
                        clearAsButton
                        onClear={() => {
                           resetTagFilters({ filtersByFieldNameToPreserve: [] })
                           setSearchValue('')
                        }}
                        clearDisabled={
                           getActiveFilterCount(filters) === 0 &&
                           !filters?.some(f => f?.fieldName === DIGIFI_FILTER_FIELD_NAMES.SORT_BY)
                        }
                        onSubmit={() => setIsMobileFilterOpen(false)}
                        totalCount={metaData?.totalCount}
                     />
                  }
               >
                  <SearchBox
                     topSpace={true}
                     searchValue={searchValue}
                     setSearchValue={setSearchValue}
                     onSearchChange={searchValue => {
                        updateFilters([
                           {
                              fieldName: DIGIFI_FILTER_FIELD_NAMES.SEARCH_QUERY,
                              value: searchValue,
                           },
                        ])
                     }}
                     placeholder={t('Search in {categoryName}', {
                        categoryName: categoryName ?? '',
                     })}
                  />
                  <MobileFilterList
                     filters={filters}
                     facets={facets}
                     updateFilters={updateFilters}
                  />
               </MobileFilterDrawer>
            </div>
            {uiConfig.showCategoryTree && hasSubCategories && (
               <div className="d-block d-lg-none">
                  <MobileFilterDrawer
                     title={t('categories')}
                  isOpen={isMobileCategoriesOpen}
                  setIsOpen={setIsMobileCategoriesOpen}
               >
                  <CategoryTree
                     category={topLevelCategory}
                     selectedCategoryId={isMobileCategoriesOpen ? categoryId : null}
                     isRootLevelComp={true}
                     initiallyExpanded={true}
                  />
                  </MobileFilterDrawer>
               </div>
            )}
         </ProductListWrapper>
      </React.Fragment>
   );
};

export default CategoryProductList;